import { Navigate, NavigateProps, useLocation } from "react-router-dom";

interface NavigateWithSearchParamsProps extends NavigateProps {
  to: string;
}

const NavigateWithSearchParams = (props: NavigateWithSearchParamsProps) => {
  const location = useLocation();
  const { to, ...rest } = props;

  return (
    <Navigate
      to={to + location.search}
      {...rest}
    />
  );
};

export default NavigateWithSearchParams;
